// extracted by mini-css-extract-plugin
module.exports = {"customButton":"Button_customButton__EzPO3"};